var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeft = function SvgArrowLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 589.6 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.9 845.5 242.5 525.1c-14.7-14.7-14.7-37.7 0-50.3l320.4-322.4c35.6-35.6 35.6-92.1 0-125.7-35.6-35.6-92.1-35.6-125.7 0L26.7 437.2c-35.6 35.6-35.6 92.1 0 125.7l408.4 410.4c35.6 35.6 92.1 35.6 125.7 0a91.77 91.77 0 0 0 2.1-127.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export default ForwardRef;